(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/views/help-start.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/views/help-start.js'); 
(function(Backbone, _, svs) {
  svs.customer_service.views.HelpStart = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.customer_service.templates.help_start(data);
    },

    initialize: function(options) {
      this.initialSelectedTab = options ? options.tab : '';
      this.setupTabs();
    },

    setupTabs: function() {
      this.tabViews = [
        {
          caption: 'Vanliga frågor',
          id: 'faq',
          className: 'common-questions',
          view: new svs.customer_service.views.CommonQuestions({
            model: svs.customer_service.models.commonQuestions || new svs.customer_service.models.CommonQuestions()
          })
        },
        {
          caption: 'Kontakt',
          id: 'kontakt',
          view: new svs.customer_service.views.Contact({
            model: svs.customer_service.models.contact || new svs.customer_service.models.Contact()
          })
        },
        {
          caption: 'Blanketter',
          id: 'blanketter-regler-och-villkor',
          view: new svs.customer_service.views.Terms({
            model: svs.customer_service.models.terms || new svs.customer_service.models.Terms()
          })
        }
      ];
    },

    onAttach: function() {
      this.renderTabs();
    },
    renderTabs: function() {
      var self = this;

      this.tabView = new svs.components.Tabs({
        tabs: this.tabViews,
        el: this.$('#help-tabview'),
        selected: self.initialSelectedTab,
        path: true,
        solidNav: true,
        defaultScroll: true,
        defaultTab: 'faq',
        slideOnDrag: !svs.core.detect.formfactor.desktop(),
        sliderOptions: { fadeinLoadedSlide: true },
        noDetectActiveTab: false
      });
    }
  });
})(Backbone, _, svs);

 })(window);